// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__7Ru14","location":"Header_location__3WFoM"};